import { useEffect, useState } from "react";
import api from "./store/api"
import CustomButton from "../../../components/CustomButton";
import AddIcon from "../../../components/Icons/add.svg";
import { Pagination, Popconfirm, Table } from "antd";
import UpdateIcon from "../../../components/Icons/update.svg";
import DeleteIcon from "../../../components/Icons/delete.svg";
import RestoreIcon from "../../../components/Icons/restore.svg";
import AuditIcon from "../../../components/Icons/audit.svg";
import Notifications from "../../../helpers/Notifications";
import { dAction } from "../../../helpers/defaultAction";
import { useDispatch, useSelector } from "react-redux";
import LocalLoading from "../../../components/Loading/Local";
import { useTranslation } from "react-i18next";
import ModalAudit from "../ModalAudit";
import dayjs from "dayjs";
import TariffRateChangeForm from "./change";
import CustomInput from "../../../components/CustomInput";
import { useDebounce } from "use-debounce";

const months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

const TariffRate = ({isModify = false}) => {
    const [visible, setVisible] = useState(false);
    const [record, setRecord] = useState(null);
    const [state, setState] = useState({ items: [], count: 0 });
    const [page, setPage] = useState(1);
    const [visibleAudit, setVisibleAudit] = useState(false)
    const [idRecordAudit, setIdRecordAudit] = useState(null)
    const [search, setSearch] = useState(null)

    const pageSize = 12;
    const { isLoading } = useSelector((state) => state.globalReducer);
    const { t } = useTranslation(["common", "valid", "action"]);
    const [searchValue] = useDebounce(search, 500)
    const dispatch = useDispatch();

    const remove = (params) => {
        dispatch(dAction(api.delete, params, changed, t('action:deleted')));
    };
    const restore = (params) => {
        dispatch(dAction(api.restore, params, changed, t('action:restored')));
    };

    useEffect(() => {
        onPaginationChange(1);
    }, [searchValue]);

    const changed = (res, message) => {
        if (res === true) {
            Notifications.successNotice(message, "", 10);
            setVisible(false);
            onPaginationChange(page);
        }
    };

    function onPaginationChange(value) {
        setPage(value);
        const params = {
            year: searchValue?.trim(),
            page: value,
            pageSize: pageSize
        };
        const func = isModify ? api.getPagedAll : api.getList;
        const sucFunction = (res) =>
            setState({ items: res.items ?? res, count: res?.count});
        dispatch(dAction(func, params, sucFunction, null));
    }

    const columns = [
        {
            title: " ",
            dataIndex: 'year',
            key: 'year',
            width: "10%",
            rowScope: 'row',
        },

    ];

    months.forEach((m, i) => {
        columns.push({
            title: t(`common:${m}`),
            dataIndex: "tariffRates",
            key: 'value',
            width: "10%",
            render: (e, record) => {
                const price = e.find(r => r.month == i+1)
                return price?.value ?? ""
            }
        })
    })

    const comColumns = [
        {
            title     : t('common:year'),
            dataIndex : 'year',
            key       : 'year',
            width     : '15%',
        },
        {
            title     : t('common:month'),
            dataIndex : 'month',
            key       : 'month',
            width     : '15%',
            render    : e => t(`common:${months[e - 1]}`),
        },
        {
            title     : t('common:value'),
            dataIndex : 'value',
            key       : 'value'
        },
    ]

    const manageColumns = [
        ...comColumns,
        {
            title       : t("common:dateCreate"),
            dataIndex   : "createDate",
            key         : "createDate",
            width       : "10%",
            render      : (date) => dayjs(date).format("DD.MM.YYYY"),
        },
        {
            dataIndex: "id",
            key: "id",
            width: 100,
            render: (id, record) => (
                <div className="changeIcon">
                    <img alt=""
                        src={UpdateIcon}
                        title={t("action:edit")}
                        onClick={() => {
                            setVisible(true);
                            setRecord(record);
                        }}
                    />
                    <Popconfirm
                        cancelText={t("no")}
                        okText={t("yes")}
                        placement="left"
                        title={
                            !record.isDeleted
                                ? t("valid:sureToDelete")
                                : t("valid:sureToRestore")
                        }
                        onCancel={(e) => {
                            e.stopPropagation();
                            return null;
                        }}
                        onConfirm={(e) => {
                            e.stopPropagation();
                            !record.isDeleted
                                ? remove({ id })
                                : restore({ id });
                        }}
                    >
                        <img alt=""
                            src={!record.isDeleted ? DeleteIcon : RestoreIcon}
                            title={
                                !record.isDeleted
                                    ? t("action:delete")
                                    : t("action:restore")
                            }
                        />
                    </Popconfirm>
                    <img alt=""
                        className="audit-icon-svg"
                        src={AuditIcon}
                        title={t('common:historyOfChange')}
                        onClick={() => {
                            setVisibleAudit(true)
                            setIdRecordAudit(id)
                        }}
                    />
                </div>
            ),
        }
    ]

    return (
        <>
            <div className="header-admin-nsi">
                <CustomInput
                    maxLength={64}
                    placeholder={`${t('action:enter')} ${t('year').toLowerCase()}`}
                    onChange={(e) => setSearch(e.target.value)}
                />
                {isModify && (
                    <CustomButton
                        className="add-nsi"
                        type="green"
                        onClick={() => {
                            setRecord(null);
                            setVisible(true);
                        }}
                    >
                        <div>
                            <img alt="" src={AddIcon}/>
                            <span>{t("action:add")}</span>
                        </div>
                    </CustomButton>
                )}
            </div>
            <Table
                columns={isModify ? manageColumns : columns}
                dataSource={state.items}
                rowKey={({id}) => id}
                loading={{indicator: <LocalLoading/>, spinning: isLoading}}
                pagination={false}
                scroll={{x: 1100, y: 800}}
            />
            {
                (isModify && state.count > pageSize) &&
                <Pagination
                    showQuickJumper
                    current={page}
                    pageSize={pageSize}
                    showSizeChanger={false}
                    size="small"
                    total={state.count}
                    onChange={onPaginationChange}
                />
            }
            {isModify && (
                <TariffRateChangeForm
                    changed={changed}
                    record={record}
                    setRecord={setRecord}
                    setVisible={setVisible}
                    visible={visible}
                    months={months}
                />
            )}
            <ModalAudit
                columns={comColumns}
                setIdRecordAudit={setIdRecordAudit}
                idRecordAudit={idRecordAudit}
                setVisible={setVisibleAudit}
                visible={visibleAudit}
                pageSize={pageSize}
                func={api.getPagedAudit}
            />
        </>
    );
};

export default TariffRate;
